import React from "react";
import auth from "../Auth";
import { NavLink } from "react-router-dom";
import Button from "@material-ui/core/Button";

class LogoutButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      keycloak: auth.user.keycloak,
      authenticated: auth.user.authenticated,
    };

    this.getButton = this.getButton.bind(this);
  }

  // TODO: Unexpected empty arrow function.
  logout = () => {
    auth.user.keycloak
      .logout()
      .then((apiResponse) => {})
      .catch((e) => {});
  };

  getButton() {
    if (auth.tokenExpired()) {
      return (
        <Button>
          {" "}
          <NavLink exact to={{ pathname: "/home/" }}>
            LOGIN{" "}
          </NavLink>
        </Button>
      );
    }
    return (
      <Button variant={"primary"} onClick={this.logout}>
        <NavLink exact to={"/#"}>
          LOGOUT{" "}
        </NavLink>
      </Button>
    );
  }

  render() {
    const self = this;

    return (
      <React.Fragment>
        {self.getButton()}
        {this.props.children}
      </React.Fragment>
    );
  }
}

export default LogoutButton;
